import { Icon } from '@acpaas-ui/react-components';

const AdvancedSearchHeader = ({ title, activeFiltersCount, isOpen, onOpen }) => {
  return (
    <div
      className="spo-m-advanced-search-header u-margin-bottom-xs u-margin-top-xs u-margin-right u-text-primary"
      onClick={onOpen}
    >
      <div>
        <h5>{title || isOpen ? 'Minder zoekopties' : 'Meer zoekopties'}</h5>
        {activeFiltersCount > 0 ? <span className="u-text-light">{activeFiltersCount} actieve filters</span> : ''}
      </div>
      <div className="is-open-icon u-flex">
        <Icon name={isOpen ? 'ai-arrow-up-1' : 'ai-arrow-down-1'} />
      </div>
    </div>
  );
};

export default AdvancedSearchHeader;
